import React from 'react';
import PropTypes from 'prop-types';

class WBMErrorMessage extends React.PureComponent {
    render() {
        switch (this.props.type) {
            case "submission":
                return (
                    <div className="error-message">
                        <span>
                            An error has occurred. Please try resubmitting. <br />
                            If the problem persists, please call 1-888-WB-MASON.
                        </span>
                    </div>
                );
            default:
                return (
                    <div className="error-message">
                        <span>
                            An error has occurred. Please try reloading the page. <br />
                            If the problem persists, please call 1-888-WB-MASON.
                        </span>
                    </div>
                );
        }        
    }
}

WBMErrorMessage.propTypes = {
    type: PropTypes.string
};

export default WBMErrorMessage;  